/**
 * A one-shot handoff (openspec change `tasks-conversations`): set by Work on this with ESI, the
 * new conversation's composer takes focus once it opens at its URL.
 */
let focusComposerOf: string | null = null;

/** Asks the composer of conversation `id` to take focus when it opens. */
export function focusComposerOnOpen(id: string): void {
  focusComposerOf = id.toLowerCase();
}

/** Whether the composer of `id` should take focus, without consuming it. */
export function composerFocusPending(id: string): boolean {
  return focusComposerOf === id.toLowerCase();
}

/** Whether the composer of `id` should take focus now (once). */
export function takeComposerFocus(id: string): boolean {
  if (composerFocusPending(id)) {
    focusComposerOf = null;
    return true;
  }
  return false;
}
